/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Panel_DescriptionInputs */

const en_newsletter_panel_description = /** @type {(inputs: Newsletter_Panel_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product updates and release notes, written like notes from the team. One email per release.`)
};

/**
* | output |
* | --- |
* | "Product updates and release notes, written like notes from the team. One email per release." |
*
* @param {Newsletter_Panel_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_panel_description = /** @type {((inputs?: Newsletter_Panel_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Panel_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_panel_description(inputs)
});